import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import useStyles from "./styles";

export default function DeleteEmployeesTableBenefitCell({
  flexValue,
  benefitValue,
}) {
  const { container } = useStyles();
  return (
    <Grid item xs={12} container className={container}>
      <Grid item container xs={6} direction="column">
        <Typography variant="body2" align="left" className="item">
          {t("common-messages.flex")}:
        </Typography>
        <Typography variant="body2" align="left" className="item">
          {t("common-messages.benefit").substr(0, 5)}.:
        </Typography>
      </Grid>
      <Grid item container xs={6} direction="column">
        <Typography variant="body2" align="right" className="item">
          {flexValue}
        </Typography>
        <Typography variant="body2" align="right" className="item">
          {benefitValue}
        </Typography>
      </Grid>
    </Grid>
  );
}

DeleteEmployeesTableBenefitCell.defaultProps = {
  flexValue: "",
  benefitValue: "",
};

DeleteEmployeesTableBenefitCell.propTypes = {
  flexValue: PropTypes.string,
  benefitValue: PropTypes.string,
};
